// extracted by mini-css-extract-plugin
module.exports = {"customLink":"talent-overview-table_customLink__Yy68-","normalContent":"talent-overview-table_normalContent__Ote3e"};